import React, { useState } from 'react'
import { GoShareAndroid } from 'react-icons/go'
import { FaFacebookF, FaLinkedinIn, FaPinterest, FaTwitter, FaWhatsapp } from 'react-icons/fa'
import PostShare from '../../components/share/PostShare'
import useAppContext from '../../hook/useAppContext'

const SharePostAction = ({item}) => {

      const [sharePost, setSharePost] = useState(false)
      const {user} = useAppContext()
      const {personal} = user 

      const url = `https://xat.me/${personal.id_xat}`
      
      const toggleSharePost = () => {

            if(!sharePost){
                  setSharePost(true)
            }
            else{
                  setSharePost(false)
            }
      }

      return (
            <div className="post_action__share">
                  <div className={sharePost ? "post_share__menu show flex" : "post_share__menu flex"}>
                        <PostShare link={`https://www.facebook.com/sharer.php?u=${url}`} tooltip={`facebook`} classObj={`facebook`} icon={<FaFacebookF />}/>
                        <PostShare link={`https://twitter.com/share?url=${url}&text=${item.title}`} tooltip={`twitter`} classObj={`twitter`} icon={<FaTwitter />}/>
                        <PostShare link={`https://www.linkedin.com/shareArticle?url=${url}&title=${item.title}`} tooltip={`linkedin`} classObj={`linkedin`} icon={<FaLinkedinIn />}/>
                        <PostShare link={`https://pinterest.com/pin/create/bookmarklet/?media=${item.cover}&url=${url}&description=${item.title}`} tooltip={`pinterest`} classObj={`pinterest`} icon={<FaPinterest />}/>
                        <PostShare link={`https://api.whatsapp.com/send?text=${item.title} ${url}`} tooltip={`whatsapp`} classObj={`whatsapp`} icon={<FaWhatsapp />}/>
                  </div>
                  <button className={sharePost ? "btn_share active flex" : "btn_share flex"} onClick={() => toggleSharePost()}>
                        <div className="share_post__icon">
                              <GoShareAndroid />
                        </div>  
                        <span>Share</span>
                  </button>
            </div>
      )
}

export default SharePostAction
